import React, { Component } from "react";

import Tableau from "./Tableau";
 
class SquadDataCleanup extends Component {
  render() {
    return (
      <div className="right-panel">
        <Tableau name="SquadDataCleanup_16204076813210&#47;SquadDataCleanup"/>
        
      </div>
    );
  }
}
 
export default SquadDataCleanup;